import React, { use } from "react";
import useAdminListSMS from "../hooks/useAdminListSMS";
import AdminListSMS from "../components/AdminListSMS";

const { sendSMS = null } = useAdminListSMS;

export default function AdminListSMSInterface(props) {
  const { onEdit, onSave, businessType, onEdit2 } = props;

  return (
    <React.Fragment>
      <AdminListSMS
        onSave={onSave}
        sendSMS={sendSMS}
        onEdit={onEdit}
        businessType={businessType}
        onEdit2={onEdit2}
      />
    </React.Fragment>
  );
}
